import { produce } from "immer";
import React from "react";
import { apiPost } from "../api";

export const ACTIVE = 0;
export const SUBMITTING = 1;
export const SUCCEED = 2;
export const FAILED = 3;

const useUnnamedComponent = (props, deps = []) => {
  const { url, initialState, handleSuccess, handleFail } = props;

  const [submitState, setSubmitState] = React.useState(ACTIVE);
  const makeFullInitialState = React.useCallback(
    () => ({
      fields:
        typeof initialState === "function" ? initialState() : initialState,
      errors: {},
      submitting: false,
    }),
    [initialState],
  );

  const [state, setState] = React.useState(makeFullInitialState);
  const stateRef = React.useRef();
  stateRef.current = state;

  React.useEffect(() => {
    // TODO: double call initialize state. optimize later.
    setState(makeFullInitialState);
  }, deps);

  const handleInputChange = React.useCallback((e) => {
    const { name, value } = e.target;
    setState(
      produce((draft) => {
        draft.fields[name] = value;
        delete draft.errors[name];
      }),
    );
  }, []);
  const inputParams = React.useCallback(
    (name) => ({
      name,
      value: stateRef.current.fields[name],
      type: "text",
      ...(stateRef.current.errors[name] && { "data-error": true }),
      onChange: handleInputChange,
    }),
    [handleInputChange],
  );

  const handleSubmit = React.useCallback((e) => {
    e.preventDefault();
    setSubmitState(SUBMITTING);
    (async () => {
      const result = await apiPost(url, {
        body: stateRef.current.fields,
      });
      if (result.statusCode === 200) {
        setSubmitState(SUCCEED);
        if (handleSuccess) handleSuccess(result);
      } else {
        setSubmitState(FAILED);
        if (handleFail) handleFail(result);
      }
    })();

    setTimeout(() => {
      setSubmitState(ACTIVE);
    }, 2000);
  }, []);

  return { inputParams, handleSubmit, submitState };
};

export default useUnnamedComponent;
